 import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { IComment } from "./proposal-social-comments.hook";

interface IBody {
  message: string;
}

interface IResponse {
  comment: IComment;
}

export function useAddProposalSocialCommentsHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/campaigns/proposals/:proposalId/socials/:proposalSocialId/comments",
  });
}
